import { ReactChild } from "react"
import { MdClose } from 'react-icons/md';
import './modal.scss';


type LoginModalProps = {
    open: boolean
    handleClose: any,
    children: ReactChild,
    headline: string,
    errorMessage?: string
}

export const Modal = ({ open, handleClose, children, headline, errorMessage }: LoginModalProps) => {


    if (!open) return <></>

    return (
        <div className='darkBG' onClick={handleClose}>
            <div className='modal' onClick={e => {e.stopPropagation() }}>
                <div className='modal__header'>
                    <div>{headline }</div>
                    <MdClose className='modal__header__close' onClick={handleClose} />
                </div>
                <div className='modal__error'>
                    {errorMessage }
                </div>
                <div className='modal__body'>
                    {children}
                </div>
            </div>
        </div>
    )
}